export const DEFAULT_NETWORK = 100;
